import React, { memo } from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import { PatternFormat } from 'react-number-format';

import FormField from './FormField';

function PhoneNumberFormField({ name, label, value, required = false, onChange, className }) {
  return (
    <FormField label={label}>
      <PatternFormat
        format="(###) ###-####"
        allowEmptyFormatting
        mask="_"
        customInput={TextField}
        variant="outlined"
        label={label}
        onChange={(event) => onChange(event.target.value, name)}
        className={className}
        value={value}
        required={required}
      />
    </FormField>
  );
}

PhoneNumberFormField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  required: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default memo(PhoneNumberFormField);
